import { fetcher } from '../utils'
import { ComponentDestinationVO } from '@repo/types'

export default async (): Promise<ComponentDestinationVO[]> => fetcher(`/api/user/destinations`, 'GET', undefined)
